// extracted by mini-css-extract-plugin
module.exports = {"btnStyle":"RegistrationButtonCalendar__btnStyle__2nQ9I"};